import * as _ from 'underscore';
import { IconSet } from './icon-set';

export interface IIcons {
	Add: string;
	AddFilter: string;
	Cancel: string;
	Delete: string;
	Edit: string;
	New: string;
	Ok: string;
	Submit: string; 
}; 

export const Icons: IIcons = {
	Add: IconSet.Add,
	AddFilter: IconSet.Add,
	Cancel: IconSet.Cancel,
	Delete: IconSet.Delete,
	Edit: IconSet.Edit,
	New: IconSet.New,
	Ok: IconSet.Ok,
	Submit: IconSet.Save 
};